module.exports = __webpack_public_path__ + "static/media/bus.9b50c7f4.svg";